import type { IntegrationStatus } from '@/api/hooks/useOrders'
import type { components } from '@/types/api/v1'
import { integrationStatusConfig } from './OrdersCellRenderers'

export type OrderProgressionState =
  components['schemas']['OrderProgressionState']

export interface OrderFilters {
  statuses: IntegrationStatus[]
  progressionStates: OrderProgressionState[]
  partnerTenantIds: string[]
}

export const EMPTY_ORDER_FILTERS: OrderFilters = {
  statuses: [],
  progressionStates: [],
  partnerTenantIds: [],
}

export interface PartnerOption {
  value: string
  label: string
}

const INTEGRATION_STATUS_VALUES = [
  'requested',
  'change_requested',
  'synced',
  'error',
  'rejected',
  'canceled',
] as const satisfies readonly IntegrationStatus[]

export const INTEGRATION_STATUS_OPTIONS = INTEGRATION_STATUS_VALUES.map(
  (value) => ({
    value,
    // Same wording the grid's own Status column uses.
    label: integrationStatusConfig[value]?.label ?? value,
  }),
)

const PROGRESSION_STATE_VALUES = [
  'No Progress',
  'Assigned',
  'Shift Started',
  'Order In Progress',
  'Loaded',
  'Dropping',
  'Complete',
  'Canceled',
] as const satisfies readonly OrderProgressionState[]

export const PROGRESSION_STATE_OPTIONS = PROGRESSION_STATE_VALUES.map(
  (value) => ({ value, label: value }),
)

export function activeFilterCount(filters: OrderFilters): number {
  return (
    filters.statuses.length +
    filters.progressionStates.length +
    filters.partnerTenantIds.length
  )
}

export function toOrderOverviewFilter(filters: OrderFilters): {
  status?: IntegrationStatus[]
  progressionState?: OrderProgressionState[]
  partnerTenantIds?: string[]
} {
  return {
    status: filters.statuses.length ? filters.statuses : undefined,
    progressionState: filters.progressionStates.length
      ? filters.progressionStates
      : undefined,
    partnerTenantIds: filters.partnerTenantIds.length
      ? filters.partnerTenantIds
      : undefined,
  }
}
